import { ICreateFuncionarioTreinamentoUseCase } from "../../../presentation/useCases/create/create_funcionario_treinamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateFuncionarioTreinamentoUseCase
 */

export class CreateFuncionarioTreinamentoUseCase implements ICreateFuncionarioTreinamentoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async createFuncionarioTreinamento(
    idFuncionario: number,
    idTreinamento: number,
    cargaHoraria: number,
    local: string,
    instrutor: string,
    dataRealização: Date,
    prazoAvaliacao: number,
  ): Promise<void> {
    await this.repository.createFuncionarioTreinamento(
      idFuncionario,
      idTreinamento,
      cargaHoraria,
      dataRealização,
      instrutor,
      local,
      prazoAvaliacao,
    );
  }
}